import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  // props: ['options'],
  data() {
    return {
      options: {
        title: {
          display: false,
          text: 'Monthly On-Time Payments',
          fontSize: 16,
          fontFamily: 'Nunito',
          padding: 0
          //fontColor: 'white',
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 5,
                precision: 0
              },
              gridLines: {
                display: true
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              }
            }
          ]
        },
        legend: {
          display: true
        },
        tooltips: {
          enabled: true,
          mode: 'single',
          callbacks: {
            label: function (tooltipItems) {
              return `${tooltipItems.datasetIndex == 0 ? 'On Time' : 'Late'}: ${
                tooltipItems.yLabel
              }`
            }
          }
        },
        layout: {
          padding: {
            top: 10,
            left: 15,
            right: 15
          }
        }
      }
    }
  },
  methods: {
    update() {
      this.$data._chart.update()
    }
  },
  mounted() {
    //eslint-disable-next-line
    // console.log(this)
    this.renderChart(this.chartData, this.options)
  }
}
